export default __webpack_public_path__ + "static/media/MarkW05-Regular.24e101bf.woff2";